/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import DynamicDropdownGeneric from "../V2_DynamicDropdown";

/**
 * Extracted from V2_Tile.tsx — Segment dropdown JSX blocks (Zero Logic Change)
 * Renders the two DynamicDropdownGeneric instances (single-dropdown + segment-dropdown)
 * that appear per-tile when selectedTileId matches.
 */
export interface SegmentSelectorProps {
  selectedTileId: string;
  card: any;
  // Single dropdown (request type) props
  selectedOptions: any;
  dialogTitle: string;
  isDropdownModalVisible: boolean;
  value: any;
  openModal: any;
  handleCancelDropdown: () => void;
  // Segment dropdown props
  segmentOptions: any;
  segmentDropdownVisible: boolean;
  hideSegmentDropdown: () => void;
  hideSegmentDropdownAfterSave?: () => void;
  subSegmentOptions: any;
  passSegmentDataToIris: (...args: any[]) => void;
  getAllSubSegmentFromSegment: (...args: any[]) => void;
  // Shared props
  setEnterprise: (...args: any[]) => void;
  isTileHasForm: boolean;
  dismissPanel: () => void;
  setOpenPanelId: (id: string) => void;
  openPanelForSMEC: (...args: any[]) => void;
  dataServiceWorkspace: any;
  isopenSegment: boolean;
  userSelectedOption: any;
  isRedirectFromAnotherForm: boolean;
  tileProfileResponse: any;
  allowRendering: boolean;
  isDetailClick: boolean;
  openWindowFrame: (...args: any[]) => void;
}

export const SegmentSelector: React.FC<SegmentSelectorProps> = (props) => {
  return (
    <>
      {props.selectedTileId === props.card.serviceID && (
        <DynamicDropdownGeneric
          numberOfDropdown={1}
          firstDropDownOptions={props.selectedOptions}
          dialogTitle={props.dialogTitle}
          dialogSubText={"Select a Request Type"}
          isVisible={props.isDropdownModalVisible}
          modalValue={props.value}
          openModal={props.openModal}
          onHide={props.handleCancelDropdown}
          onCancel={props.handleCancelDropdown}
          setEnterprise={props.setEnterprise}
          card={props.card}
          isTileHasForm={props.isTileHasForm}
          dismissPanel={props.dismissPanel}
          setOpenPanelId={props.setOpenPanelId}
          openPanelForSMEC={props.openPanelForSMEC}
          dataServiceWorkspace={props.dataServiceWorkspace}
          isopenSegment={props.isopenSegment}
          userSelectedOption={props.userSelectedOption}
          isRedirectFromAnotherForm={props.isRedirectFromAnotherForm}
          tileProfileResponse={props.tileProfileResponse}
          isAllowRendering={props.allowRendering}
          isDetailClick={props.isDetailClick}
          openWindowFrame={props.openWindowFrame}
        />
      )}

      {props.selectedTileId === props.card.serviceID && (
        <DynamicDropdownGeneric
          numberOfDropdown={2}
          firstDropDownOptions={props.segmentOptions}
          dialogTitle={props.dialogTitle}
          isVisible={props.segmentDropdownVisible}
          onHide={props.hideSegmentDropdown}
          onCancel={props.hideSegmentDropdown}
          onHideAfterSave={props.hideSegmentDropdownAfterSave}
          secondDropDownOptions={props.subSegmentOptions}
          passSegmentDataToIris={props.passSegmentDataToIris}
          getAllSubSegmentFromSegment={props.getAllSubSegmentFromSegment}
          setEnterprise={props.setEnterprise}
          card={props.card}
          isTileHasForm={props.isTileHasForm}
          dismissPanel={props.dismissPanel}
          setOpenPanelId={props.setOpenPanelId}
          openPanelForSMEC={props.openPanelForSMEC}
          dataServiceWorkspace={props.dataServiceWorkspace}
          isopenSegment={props.isopenSegment}
          userSelectedOption={props.userSelectedOption}
          isRedirectFromAnotherForm={props.isRedirectFromAnotherForm}
          tileProfileResponse={props.tileProfileResponse}
          isAllowRendering={props.allowRendering}
          isDetailClick={props.isDetailClick}
          openWindowFrame={props.openWindowFrame}
        />
      )}
    </>
  );
};
